import React, { useState } from "react";
import { Modal, TextField, Button, Box } from "@mui/material";
import { H4, H5 } from "./Typography";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

type FormValues = {
  category: string;
  subject: string;
  description: string;
};

type FormErrors = {
  category?: string;
  subject?: string;
  description?: string;
};

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: (value: any) => void;
  data?: any;
};

function AddTicketModal({ open, handleClose, handleSave }: MyModalProps) {
  const [formValues, setFormValues] = useState<FormValues>({
    category: "",
    subject: "",
    description: "",
  });
  const [formErrors, setFormErrors] = useState<FormErrors>({});

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" });
  }

  const handleRelationShip = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      category: event.target.value,
    }));
  };

  const handleSaveClick = () => {
    const newErrors: FormErrors = {};

    if (!formValues.category) {
      newErrors.category = "Please select a category.";
    }
    if (!formValues.subject) {
      newErrors.subject = "Subject cannot be empty.";
    }

    if (!formValues.description) {
      newErrors.description = "Description cannot be empty.";
    }

    // if there are errors, update guardianRelationship with them
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      handleSave(formValues);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Create Ticket
          </H5>
        </Box>
        <Box sx={container}>
          <Select
            sx={selectedView}
            error={!!formErrors.category}
            //helperText={formErrors.subject}
            value={formValues.category ? formValues.category : ""}
            required
            onChange={handleRelationShip}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <H4 style={{ color: "#C0C0C0" }}>Select Category</H4>;
              }
              return selected;
            }}
          >
            <MenuItem disabled value="">
              <H4>Select Category</H4>
            </MenuItem>
            <MenuItem value={"Installation Crash"}>Installation Crash</MenuItem>
            <MenuItem value={"Login/Account Issues"}>
              Login/Account Issues
            </MenuItem>
            <MenuItem value={"KYC Issue"}>KYC Issue</MenuItem>
            <MenuItem value={"KYC Re-initiate"}>KYC Re-initiate</MenuItem>
            <MenuItem value={"Fund Purchase Issue"}>
              Fund Purchase Issue
            </MenuItem>
            <MenuItem value={"Fund Redemption Issue"}>
              Fund Redemption Issue
            </MenuItem>
            <MenuItem value={"Piggy Bank Issue"}>Piggy Bank Issue</MenuItem>
            <MenuItem value={"Others"}>Others</MenuItem>
          </Select>
          <TextField
            label="Subject"
            name="subject"
            value={formValues.subject ? formValues.subject : ""}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
          />
          <TextField
            label="Description"
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            name="description"
            value={formValues.description}
            error={!!formErrors.description}
            helperText={formErrors.description}
            multiline
            rows={4}
          />

          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleClose} sx={cancel}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddTicketModal;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const selectedView = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "98%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 2,
  },
  height: 55,
};
const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "100%",
  justifyContent: "space-between",
  flexDirection: {
    md: "row",
    xs: "column",
  },
  display: "flex",

  mt: {
    md: 2.5,
    xs: 1,
  },
};

const cancel = {
  background: "#FFF5D1",
  color: "#000",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "98%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 1.5,
  },
};
